<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_1 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<div class="tour-step-21">
			<template v-if="!isCoordinatore">
				<v-row v-if="isAccountManager">
					<v-col class="d-flex justify-end mb-3">
						<v-btn
							color="secondary"
							@click="downloadAllFiles()"
							:disabled="isLoading || nessunFileCaricato"
						>
							{{ nessunFileCaricato ? 'Nessun documento caricato' : 'Scarica tutti i documenti' }}
						</v-btn>
					</v-col>
				</v-row>
				
				<div
					:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
					class="mt-5 mb-8"
				></div>
				
				<!-- CONTRATTO DI SERVIZIO -->
				<v-row>
					<v-col>
						<div>
							<p>
								Carica nel riquadro qui in basso il <b>Contratto di Servizio che hai firmato con noi</b>. Se non lo hai ancora firmato, ti invitiamo a farlo il prima possibile, una copia del contratto ti è stata inviata tramite email dal nostro commerciale.
							</p>
							<p>
								Se hai firmato con noi un Accordo di Prenotazione <b>carica qui solo il Contratto di Servizio e non l'Accordo</b> che invece puoi già trovare nella sezione "Materiale informativo" in alto nel menù.
							</p>
							<p
								v-if="pratica.accordo.cliente.tipologia != 'Azienda'"
								class="mb-0"
							>
								⚠️ NOTA BENE: Se sei un consulente e hai un unico contratto di servizio per più pratiche, devi caricare quel singolo contratto solo nella prima pratica (seleziona l’Opzione 1 qui sotto).<br>
								Poi nelle altre pratiche lo devi selezionare dal menù a tendina, senza caricarlo di nuovo (seleziona l’Opzione 2 qui sotto).<br>
								Ti preghiamo di fare attenzione a <b>non caricare mai due volte lo stesso contratto su più pratiche</b>.
							</p>
						
						</div>
						
						<v-radio-group
							v-if="pratica.accordo.cliente.tipologia != 'Azienda'"
							v-model="contrattoDiServizioOption"
							hide-details
							:readonly="action == 'show'"
							:disabled="isLoading || tourIsRunning || pratica.idPraticaConContrattoDiServizio !== null || files.contratto_di_servizio !== null"
							class="mt-0"
						
						>
							<v-radio
								label="Opzione 1: Questa pratica è associata a un nuovo contratto che stai caricando per la prima volta"
								value="option_1"
								class="mb-1"
							></v-radio>
							<v-radio
								label="Opzione 2: Questa pratica è associata a un contratto che hai già caricato precedentemente"
								value="option_2"
							></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				
				<v-row v-if="canIShowContrattoDiServizioFileInput">
					<v-col>
						<!-- TODO: al momento l'eliminazione del contratto di servizio non è gestita per varie necessità -->
						<v-badge
							:value="haveFilesBeenModified.contratto_di_servizio"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.contratto_di_servizio"
								label="Contratto di servizio"
								outlined
								dense
								clearable
								hide-details
								accept=".pdf"
								truncate-length="120"
								@change="setFileChanged(files.contratto_di_servizio)"
								@click:clear="onContrattoDiServizioClear()"
								:loading="isLoadingContrattoDiServizio"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
								>
									<template v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isLoadingContrattoDiServizio">
										<v-progress-circular
											v-if="downloadingContrattoDiServizio"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<v-icon
										v-if="files.contratto_di_servizio !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.contratto_di_servizio)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</v-col>
				</v-row>
				<v-row v-else-if="action == 'show' || (isCliente && pratica.id_stato_fase_1 == 77)">
					<v-col>
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_contratto_di_servizio)"
							label="Contratto di servizio"
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingContrattoDiServizio"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.contratto_di_servizio"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_modulo_domanda, 'contratto_di_servizio')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</v-col>
				</v-row>
				
				<v-row v-if="contrattoDiServizioOption == 'option_2'">
					<v-col>
						<!--:value="praticaDiff.includes('contratto_di_servizio_id')"-->
						<v-badge
							:value="praticaDiff.includes('idPraticaConContrattoDiServizio')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-autocomplete
								:items="praticheConContrattiDiServizio"
								v-model="pratica.idPraticaConContrattoDiServizio"
								:loading="isLoadingPraticheConContrattiDiServizio"
								label="Scegli un Contratto di servizio già associato ad una pratica"
								item-value="id"
								item-text="nome_file_custom_id"
								outlined
								dense
								clearable
								:disabled="isLoading || tourIsRunning || (isCliente && pratica.id_stato_fase_1 == 77)"
							></v-autocomplete>
						</v-badge>
					</v-col>
				</v-row>
				
				<div
					:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
					class="mt-5 mb-8"
				></div>
			</template>
			
			<!-- MODULO DI CONVALIDA -->
			<v-row class="mb-2">
				<v-col>
					<div class="mb-4">
						Carica il <b>Modulo di Domanda</b> in formato PDF cliccando sul riquadro qui in basso. Questo modulo sarà disponibile al termine della preconvalida della domanda e potrà essere scaricato nella sezione “Le mie richieste” cliccando sul pulsante 'Scaricare il PDF generato', all’interno della colonna “Azioni”. È importante inviare il modulo senza effettuare modifiche o spostamenti dei dati, per evitare errori che potrebbero compromettere le fasi successive di invio della domanda e il ricevimento dei fondi.
					</div>
					
					<template
						v-if="action == 'store'
						|| (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 77) || isAccountManager))"
					>
						<v-badge
							:value="haveFilesBeenModified.modulo_domanda"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.modulo_domanda"
								label="Modulo di Domanda"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setFileChanged(files.modulo_domanda)"
								@click:clear="pratica.path_modulo_domanda = null"
								:loading="isLoadingModuloDomanda"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
								>
									<template v-if="pratica.path_modulo_domanda !== null && !isLoadingModuloDomanda">
										<v-progress-circular
											v-if="downloadingModuloDomanda"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.path_modulo_domanda, 'modulo_domanda')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
									<v-icon
										v-if="files.modulo_domanda !== null"
										class="ml-3"
										@click="viewFileInBrowser(files.modulo_domanda)"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					<template v-else-if="action == 'show' || isCoordinatore || (isCliente && pratica.id_stato_fase_1 == 77)">
						<v-text-field
							:value="getFileNameFromPath(pratica.path_modulo_domanda)"
							label="Modulo di Domanda"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.path_modulo_domanda !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingModuloDomanda"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_modulo_domanda, 'modulo_domanda')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
								<template>
									<v-progress-circular
										v-if="isGettingFile.modulo_domanda"
										size="24"
										width="3"
										color="primary"
										indeterminate
										class="ml-3"
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="getFileAndViewInBrowser(pratica.path_modulo_domanda, 'modulo_domanda')"
									>
										mdi-eye-outline
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
			
			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>
			
			<!-- CODICE UNIVOCO DI PRECONVALIDA -->
			<v-row>
				<v-col>
					Carica il <b>Codice Univoco di Preconvalida</b>. Questo codice è essenziale per il Click Day ed è disponibile solo dopo aver effettuato la Preconvalida della domanda. Il <b>codice univoco di preconvalida</b> è presente nel modulo di domanda generato in formato PDF al termine della preconvalida. Questo codice si trova in verticale sul lato sinistro del documento ed è evidenziato in rosso, preceduto dalla dicitura "<b>Domanda numero...</b>".<br>
					Per maggiori informazioni, ti invitiamo a consultare il manuale utente disponibile a questo link:<br>
					<a href="https://strumenti.ismea.it/ismea-bundle-6a96b0f9/ismea-ms/api/v1/upload/evaluation/Manuale_FondoInnovazione24-1731621738.pdf">
						https://strumenti.ismea.it/ismea-bundle-6a96b0f9/ismea-ms/api/v1/upload/evaluation/Manuale_FondoInnovazione24-1731621738.pdf
					</a><br>
					Inviaci questo codice così come lo vedi nel documento senza effettuare alcuna modifica, per minimizzare il rischio di generare errori che potrebbero compromettere le successive fasi di invio della domanda e quindi del ricevimento dei fondi.
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('codice_univoco_di_preconvalida')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.codice_univoco_di_preconvalida"
							@input="pratica.codice_univoco_di_preconvalida = $event !== '' ? $event : null"
							label="Codice Univoco di Preconvalida"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 77) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>
			
			<!-- NOME UTENTE -->
			<v-row>
				<v-col>
					Inserisci il nome utente utilizzato per registrare l'azienda al portale ISMEA. <b>Deve essere quello dell'azienda per cui verrà inviata la domanda.</b> Non utilizzare il nome utente del delegato, ma solo quello dell'azienda associata a questa pratica.
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('nome_utente')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.nome_utente"
							@input="pratica.nome_utente = $event !== '' ? $event : null"
							label="Nome Utente"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 77) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>
			
			<!-- PASSWORD -->
			<v-row>
				<v-col>
					Inserisci la <b>password associata al nome utente</b> utilizzato per registrare l'azienda al portale ISMEA. Assicurati che sia la password corretta per accedere con il profilo dell'azienda e non con quello di un delegato.
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('password')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.password"
							@input="pratica.password = $event !== '' ? $event : null"
							label="Password"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 77) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>
			
			<v-row>
				<v-col>
					Inserisci l'indirizzo PEC verificato nell'ultima pagina prima di effettuare la preconvalida. Deve essere la PEC dell'azienda che riceverà le comunicazioni ufficiali e corrisponde a quella presente nel modulo di domanda. <b>Questo dato non verrà utilizzato</b>, tranne in casi di emergenza qualora l'ente richiedesse questa informazione in fase di convalida.
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('pec')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.pec"
							@input="pratica.pec = $event !== '' ? $event : null"
							label="PEC Validata"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 77) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
							:rules="[mixin_rules.email]"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<div
				:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
				class="mt-5 mb-8"
			></div>
			
			<v-row class="mt-6">
				<v-col>
					Infine inserisci in basso un <b>numero di telefono che deve appartenere alla persona responsabile della pratica</b> che ha a disposizione tutte le informazioni sul progetto e sull’azienda che sta partecipando al Click Day e <b>DEVE essere reperibile il giorno e nella fascia oraria del Click Day</b>.
					Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day. Consigliamo di inserire un <b>numero di cellulare</b> o in alternativa un numero fisso (<b>no centralino</b>).
				
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('numero_di_emergenza')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.numero_di_emergenza"
							@input="pratica.numero_di_emergenza = $event !== '' ? $event : null"
							label="Numero di emergenza"
							outlined
							dense
							:readonly="(isCliente && pratica.id_stato_fase_1 == 77) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
							:rules="[mixin_rules.numero_di_emergenza]"
						>
							<template v-slot:append>
								<v-tooltip
									bottom
									color="primary"
								>
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">
											mdi-help-circle-outline
										</v-icon>
									</template>
									Nel caso si volessero inserire più numeri di emergenza separarli con un trattino (-)
								</v-tooltip>
							</template>
						</v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<!--<v-row class="mt-0">-->
			<!--	<v-col>-->
			<!--		Questo numero deve appartenere alla persona che ha a disposizione tutte le informazioni sull’azienda che sta partecipando al Click Day e DEVE essere reperibile il giorno e nella fascia oraria del Click Day.<br>-->
			<!--		Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day.-->
			<!--	</v-col>-->
			<!--</v-row>-->
			
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
const mime = require('mime');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			isSettingPratica: false,
			pratica: {
				id: null,
				accordo_id: null,
				id_stato_fase_1: null,
				ci_sono_aggiornamenti_fase_1: false,
				pec: null,
				numero_di_emergenza: null,
				priorita: null,
				path_modulo_codice_clickday: null,
				path_modulo_domanda: null,
				contratto_di_servizio_id: null,
				contratto_di_servizio: {
					id: null,
					path_contratto_di_servizio: null
				},
				idPraticaConContrattoDiServizio: null // dato extra aggiunto
			},
			files: {
				modulo_codice_clickday: null,
				modulo_domanda: null,
				contratto_di_servizio: null
			},
			isLoadingModuloCodiceClickday: false,
			isLoadingModuloDomanda: false,
			isLoadingContrattoDiServizio: false,
			
			praticheConContrattiDiServizio: [],
			isLoadingPraticheConContrattiDiServizio: false,
			
			downloadingModuloCodiceClickday: false,
			downloadingModuloDomanda: false,
			downloadingContrattoDiServizio: false,
			
			contrattoDiServizioOption: null
		}
	},
	
	created() {
		this.isSettingPratica = true;
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_1 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_1');
		}
		
		if (this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 && this.isAccountManager) {
			this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_per_account_manager_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_per_account_manager_fase_1');
		}
		
		if (this.pratica.path_modulo_codice_clickday !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getModuloCodiceClickday();
		}
		
		if (this.pratica.path_modulo_domanda !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getModuloDomandaClickDay();
		}
		
		if (this.pratica.contratto_di_servizio.path_contratto_di_servizio !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getContrattoDiServizio();
		}
		
		this.getPraticheConContrattoDiServizio();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isAzienda: 'auth/isAzienda',
			isCoordinatore: 'auth/isCoordinatore',
			tourIsRunning: 'tour/isRunning'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingModuloCodiceClickday
				|| this.isLoadingModuloDomanda
				|| this.isLoadingContrattoDiServizio
				|| this.isLoadingPraticheConContrattiDiServizio;
		},
		nessunFileCaricato() {
			return this.pratica.path_modulo_codice_clickday === null
				&& this.pratica.path_modulo_domanda === null
				&& this.pratica.contratto_di_servizio.path_contratto_di_servizio === null;
		},
		// TODO: semplificare/ordinare la logica di questo metodo...
		canIShowContrattoDiServizioFileInput() {
			return this.action == 'store'
				|| (
					this.action == 'edit' // i clienti agiscono sempre in edit
					&& (
						(
							this.isCliente
							&& this.pratica.id_stato_fase_1 != 77
							&& (
								(
									(
										this.contrattoDiServizioOption == 'option_1'
										|| this.files.contratto_di_servizio !== null
									)
									&& !this.isAzienda
								)
								|| this.isAzienda
							)
						)
						|| (
							this.isAccountManager
							&& (
								this.contrattoDiServizioOption == 'option_1' // selezionabile solo se la pratica non è di un'azienda singola
								|| this.files.contratto_di_servizio !== null
							)
							|| this.pratica.accordo.cliente.tipologia == 'Azienda'
						)
					)
				)
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica);
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		}
	},
	
	methods: {
		async getModuloCodiceClickday() {
			this.isLoadingModuloCodiceClickday = true;
			this.files.modulo_codice_clickday = await this.getFile(this.pratica.path_modulo_codice_clickday);
			this.files.modulo_codice_clickday.changed = false;
			this.isLoadingModuloCodiceClickday = false;
		},
		async getModuloDomandaClickDay() {
			this.isLoadingModuloDomanda = true;
			this.files.modulo_domanda = await this.getFile(this.pratica.path_modulo_domanda);
			this.files.modulo_domanda.changed = false;
			this.isLoadingModuloDomanda = false;
		},
		async getContrattoDiServizio() {
			this.isLoadingContrattoDiServizio = true;
			this.files.contratto_di_servizio = await this.getFile(this.pratica.contratto_di_servizio.path_contratto_di_servizio);
			this.files.contratto_di_servizio.changed = false;
			this.isLoadingContrattoDiServizio = false;
		},
		getPraticheConContrattoDiServizio() {
			this.isLoadingPraticheConContrattiDiServizio = true;
			axios.get(`/api/pratiche?pratiche_con_contratto_di_servizio=true&accordo_id=${this.pratica.accordo_id}`)
				.then(response => {
					this.praticheConContrattiDiServizio = response.data;
				})
				.finally(() => {
					this.isLoadingPraticheConContrattiDiServizio = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'modulo_codice_clickday') this.downloadingModuloCodiceClickday = true;
			else if (key == 'modulo_domanda') this.downloadingModuloDomanda = true;
			else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = true;
			axios.post('/api/storage/download',
				{
				path: path
			},
				{
				responseType: 'blob'
			})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'modulo_codice_clickday') this.downloadingModuloCodiceClickday = false;
					else if (key == 'modulo_domanda') this.downloadingModuloDomanda = false;
					else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = false;
				})
		},
		setFileChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		onContrattoDiServizioClear() {
			this.pratica.contratto_di_servizio.path_contratto_di_servizio = null;
			this.pratica.contratto_di_servizio_id = null;
			this.pratica.contratto_di_servizio = Object.assign({}, this.praticaVoid.contratto_di_servizio);
			this.$emit('update-fase-2-key');
			this.$emit('update-fase-8-key');
			this.$emit('update-fase-9-key');
		},
		downloadAllFiles() {
			if (this.pratica.path_modulo_codice_clickday) {
				this.download(this.pratica.path_modulo_codice_clickday, 'modulo_codice_clickday');
			}
			
			if (this.pratica.path_modulo_domanda) {
				this.download(this.pratica.path_modulo_domanda, 'modulo_domanda');
			}
			
			if (this.pratica.contratto_di_servizio.path_contratto_di_servizio) {
				this.download(this.pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio');
			}
		}
	}
	
}
</script>

<style scoped>

</style>